
import { useDispatch } from "react-redux";
import {useEffect} from "react";

const PopupMsg = ({message, close}) => {
    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(close)
    }

    useEffect(() => {
      if (document.activeElement.tagName === "INPUT" || document.activeElement.tagName === "TEXTAREA") {
        document.activeElement.blur();
      }
    },[])

    return (
        <div className="modal modal-error">
            <div className="modal__overlay" onClick={() => closeModal()}></div>
            <div className="modal__container">
                <div className="modal-close" onClick={() => closeModal()}></div>
                <div className="modal__body">
                    <div className="modal__title">Ошибка!</div>
                    <div className="modal__text">{message}</div>
                </div>
            </div>
        </div>
    )

}

export default PopupMsg